import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@walmart-web/livingdesign-components';

import NotificationsSection from '../NotificationsSection/index.tsx';
import { NotificationsListState } from '../index.tsx';
import NotificationSkeletonLoader from '../NotificationSkeletonLoader/index.tsx';
import NoResults from '../NoResults/index.tsx';

type Props = {
  data: NotificationsListState;
  loading: boolean;
};

const UnreadNotifications: FC<Props> = ({ loading, data }) => {
  const { t } = useTranslation('profile');

  const sections = [
    {
      key: 'new',
      label: t('notifications.new'),
      data: data.unread
    }
  ];

  return (
    <Grid style={{ width: '100%' }}>
      {sections.map(
        ({ key, data: unreadData, ...restSectionData }) =>
          unreadData.length > 0 && (
            <NotificationsSection
              key={key}
              data={unreadData}
              {...restSectionData}
            />
          )
      )}
      {loading && <NotificationSkeletonLoader count={4} />}
      {!loading && data.unread.length === 0 && <NoResults />}
    </Grid>
  );
};

export default UnreadNotifications;
